var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrappedEthereumIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    focusable: "false",
    className: "chakra-icon token-icon",
    "data-id": "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.9898 0L47.3457 2.18771V65.6644L47.9898 66.307L77.4543 48.8902L47.9898 0Z",
    fill: "#DF5960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9907 0L18.5254 48.8902L47.9907 66.307V35.4971V0Z",
    fill: "#EE9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9899 71.8882L47.627 72.3309V94.9422L47.9899 96.0019L77.4726 54.4805L47.9899 71.8882Z",
    fill: "#DF5960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9907 96.0019V71.8882L18.5254 54.4805L47.9907 96.0019Z",
    fill: "#EE9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9902 66.3059L77.4548 48.8892L47.9902 35.4961V66.3059Z",
    fill: "#CF373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5254 48.8892L47.9907 66.3059V35.4961L18.5254 48.8892Z",
    fill: "#DF5960"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eth-clip-1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrappedEthereumIcon);
export default __webpack_public_path__ + "static/media/wrapped_ethereum_icon.67027acf.svg";
export { ForwardRef as ReactComponent };